// removed by extract-text-webpack-plugin
module.exports = {"input":"src-components-SearchForm-__SearchForm-module___input"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SearchForm/SearchForm.module.css
// module id = 93
// module chunks = 0